import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useCompanySchedule } from '@/api/company'
import { useFirstCompany } from '@/api/profile'
import { useHeuresNumero } from '@/api/phoneNumbers'
import type { IvrAvailableResources } from '@/api/ivrFlows'
import { resumeHeures } from '@/components/manager/numbers/HeuresDuNumero'
import { useManagerNavigation } from '@/components/manager/useManagerNavigation'

/**
 * Les heures que vérifie le nœud « Heures d'ouverture », pour information : celles
 * du numéro appelé s'il en a, sinon celles de l'entreprise (serveur :
 * _is_open(company, phone_number=numéro appelé)). Rien ne se modifie ici : on dit
 * lesquelles s'appliquent et on mène à l'endroit où elles se règlent.
 */
export function HeuresDuNoeud({ flowId, resources }: { flowId: number; resources: IvrAvailableResources | undefined }) {
  const { t } = useTranslation()
  const { data: entreprise } = useFirstCompany()
  const { setActiveTab: allerA } = useManagerNavigation()
  const numeros = (resources?.phone_numbers ?? []).filter((n) => n.ivr_flow === flowId)
  const unSeul = numeros.length === 1 ? numeros[0] : null
  const { data: duNumero } = useHeuresNumero(unSeul ? entreprise?.id : undefined, unSeul?.id)
  const { data: horaire } = useCompanySchedule(entreprise?.id)
  const k = (cle: string, options?: Record<string, unknown>) => t(`manager.flows.editor.config.heures.${cle}`, options)

  const propresAuNumero = !!unSeul && !!duNumero && !duNumero.use_company_hours
  const jours = propresAuNumero ? duNumero?.days : horaire?.days
  const numero = unSeul ? unSeul.friendly_name || unSeul.number : ''

  let explication = k('entrepriseSeule')
  if (propresAuNumero) explication = k('duNumero', { numero })
  else if (unSeul) explication = k('numeroSuitEntreprise', { numero })
  else if (numeros.length > 1) explication = k('plusieursNumeros')

  return (
    <div className="space-y-2 rounded-lg border p-3">
      <p className="text-sm font-medium">
        {k('appliquees')}
        {jours && <span className="ml-2 font-normal text-gray-500">{resumeHeures(jours, t)}</span>}
      </p>
      <p className="text-xs text-gray-500">{explication}</p>
      <Button variant="outline" size="sm" onClick={() => allerA(propresAuNumero ? 'numbers' : 'schedule')}>
        {propresAuNumero ? k('modifierNumero') : k('modifierEntreprise')}
      </Button>
    </div>
  )
}
